import { BackButton } from '../components/layout';

const FeedbackReports = () => {
  return (
    <div className="max-w-7xl mx-auto">
      <BackButton />
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Feedback Reports</h1>
        <p className="text-gray-600">Analysis of student feedback and responses</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Response Trends</h2>
          {/* Add response trends chart component here */}
          <p className="text-gray-600">Coming soon...</p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Category Analysis</h2>
          {/* Add category analysis component here */}
          <p className="text-gray-600">Coming soon...</p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Student Sentiment</h2>
          {/* Add sentiment analysis component here */}
          <p className="text-gray-600">Coming soon...</p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Question Breakdown</h2>
          {/* Add question breakdown component here */}
          <p className="text-gray-600">Coming soon...</p>
        </div>
      </div>
    </div>
  );
};

export default FeedbackReports;